import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { SANTAS_GRAY, WHITE } from '@/constants/colors';

// UTILITY
import breakpoints from '@/utility/breakpoints';

export const Container = styled.div`
  .content-hero,
  &.content-hero {
    background-color: ${p => p.theme.palette.background.contentHero};

    &--left-bg {
      .page-content {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::before {
          right: 100%;
        }
      }
    }

    &--right-bg {
      .page-content {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::after {
          left: 100%;
        }
      }
    }

    &--lighten {
      color: ${WHITE};

      .MuiInputBase-root {
        background-color: ${WHITE};
        box-shadow: 0 4px 24px rgba(42, 42, 53, 0.15);

        input {
          &::placeholder {
            color: ${SANTAS_GRAY};
          }
        }

        &.Mui-disabled {
          background-color: ${rgba(WHITE, 0.7)};
        }
      }

      .MuiButtonBase-root {
        background-color: transparent;
        border: 2px solid ${WHITE};
        padding-top: 15px;
        padding-bottom: 15px;

        &:disabled {
          color: ${rgba(WHITE, 0.7)};
          border: 2px solid ${rgba(WHITE, 0.7)};
        }
      }
    }

    &__title {
      padding-top: 38px;
    }

    &__subtitle {
      margin-top: 5px;

      ${breakpoints.down('xs')} {
        margin-top: 10px;
        line-height: 2.4rem;
      }
    }

    &__content {
      padding: 20px 0;
      position: relative;
    }

    .sticky-outer-wrapper.active {
      .content-hero__content {
        background-color: ${p => p.theme.palette.background.contentHero};

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::before {
          left: 100%;
        }

        &::after {
          right: 100%;
        }
      }
    }
  }
`;

export default Container;
